var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section-filters"},[_c('LeadsFiltersSelected',{attrs:{"page-kind":_vm.pageKind}}),_c('div',{staticClass:"filters-list"},[_c('LeadsFiltersDropdowns',{attrs:{"pageKind":_vm.pageKind,"kindPrefix":_vm.kindPrefix}}),_c('LeadsFiltersDate',{attrs:{"pageKind":_vm.pageKind}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }